import { render, staticRenderFns } from "./CardSelect.vue?vue&type=template&id=1929b2fc&scoped=true"
import script from "./CardSelect.vue?vue&type=script&lang=ts"
export * from "./CardSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929b2fc",
  null
  
)

export default component.exports